// ValidationDisplay — toont soft-warning onder een item.
// Soft-warning blokkeert niet; wel een "Toevoegen aan risicoregister"-knop.

import React from 'react';
import { Alert, Button, Stack } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useTranslation } from 'react-i18next';

export default function ValidationDisplay({ warning, onAddToRegister, inRegister }) {
    const { t } = useTranslation();
    if (!warning) { return null; }

    return (
        <Alert
            severity={warning.severity === 'hard_block' ? 'error' : 'warning'}
            sx={{ mt: 1 }}
            action={
                onAddToRegister && !inRegister ? (
                    <Button
                        color="inherit"
                        size="small"
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={onAddToRegister}
                    >
                        {t('risk.addToRegister')}
                    </Button>
                ) : null
            }
        >
            <Stack spacing={0.5}>
                <strong>{warning.message || warning.name || 'Afwijking geconstateerd'}</strong>
                {warning.help && <span>{warning.help}</span>}
            </Stack>
        </Alert>
    );
}
